import { cn } from 'cn';
import * as React from 'react';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div aria-hidden className={cn('animate-pulse rounded bg-muted', className)} {...props} />;
}

export { Skeleton };
